var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZerotofive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 56,
    viewBox: "0 0 26 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.543 19.158a6.993 6.993 0 1 1 13.986 0 6.993 6.993 0 0 1-13.986 0zm6.993-4.045a4.045 4.045 0 1 0 0 8.09 4.045 4.045 0 0 0 0-8.09zM5.16 33.527h-.368V44.948a7.737 7.737 0 0 0 15.474 0V33.527H5.161zM2.817 31.55a3.316 3.316 0 0 1 2.345-.97h14.737a3.316 3.316 0 0 1 3.315 3.315v11.053a10.684 10.684 0 1 1-21.368 0V33.895c0-.88.35-1.723.971-2.345z",
    fill: "#595959",
    stroke: "#fff",
    strokeWidth: 0.737
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.573 7.21c.616 0 1.116-.5 1.116-1.116V1.116a1.116 1.116 0 1 0-2.232 0v4.978c0 .616.5 1.116 1.116 1.116zM4.394 6.267a1.112 1.112 0 0 0 1.579-.001 1.116 1.116 0 0 0-.002-1.579L1.904.63a1.116 1.116 0 1 0-1.576 1.58l4.066 4.058zM19.96 6.593c.285 0 .57-.109.788-.326l4.064-4.059A1.116 1.116 0 1 0 23.235.63L19.17 4.688a1.116 1.116 0 0 0 .789 1.905z",
    fill: "#88A13B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZerotofive);
export default __webpack_public_path__ + "static/media/zerotofive.93ed625de2b3d06f2ab557fb98d4d624.svg";
export { ForwardRef as ReactComponent };